import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideState, provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { prependEndpointInterceptor } from './intercepters/prepend-endpoint/prepend-endpoint.interceptor';
import { attachJwtTokenInterceptor } from './intercepters/attach-jwt-token/attach-jwt-token.interceptor';
import { providePrimeNG } from 'primeng/config';
import * as fromAuth from '@auth/lib/+state/auth.reducer';
import { AuthEffects } from '@auth/lib/+state/auth.effects';
import { AuthFacade } from '@auth/lib/+state/auth.facade';
import {TPLAura} from "./components/primeng-theme";
import {CoreUiEffects} from "@core/lib/+state/core-ui.effects";
import * as fromCoreUi from "@core/lib/+state/core-ui.reducer";

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useValue: Sentry.createErrorHandler() },
    provideEffects(CoreUiEffects),
    provideState(fromCoreUi.CORE_UI_FEATURE_KEY, fromCoreUi.coreUiReducer),
    provideStore(),
    provideEffects(),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([prependEndpointInterceptor, attachJwtTokenInterceptor])
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    providePrimeNG({
      theme: {
        preset: TPLAura,
        options: {
          darkModeSelector: false,
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
    }),
    provideState(fromAuth.AUTH_FEATURE_KEY, fromAuth.authReducer),
    provideEffects(AuthEffects),
    AuthFacade,
  ],
};
